module.exports = __webpack_public_path__ + "img/p9.dd96792b.png";